import { render, staticRenderFns } from "./VaNotification.demo.vue?vue&type=template&id=1eccc440&"
import script from "./VaNotification.demo.vue?vue&type=script&lang=js&"
export * from "./VaNotification.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports